module.exports = __webpack_public_path__ + "static/media/STRATEGY-ICON.22ada808.svg";